module.exports = __webpack_public_path__ + "img/hk-icon.79dbd0dc.png";